export default __webpack_public_path__ + "static/partner14-c349cb104d3d25cbcf6036e1b4169c30.png";